/**
 * Нормализация CSS-веса шрифта → PascalCase суффикс файла шрифта.
 *
 * Фронт сохраняет в модель CSS-lowercase значения (`'normal'`, `'bold'`)
 * или numeric weights (`400`, `700`, …).
 * TTF-файлы именуются PascalCase: `Inter-Regular.ttf`, `Inter-Bold.ttf`.
 *
 * Возвращает ключ как есть, если он не найден в таблице — вызывающая сторона
 * сама решает, что с этим делать (например, подставить `Regular` или бросить).
 */
export const FONT_WEIGHT_NORMALIZE: Readonly<Record<string, string>> = {
  // CSS keyword → PascalCase
  normal: 'Regular',
  regular: 'Regular',
  light: 'Light',
  medium: 'Medium',
  semibold: 'SemiBold',
  bold: 'Bold',
  thin: 'Thin',
  extralight: 'ExtraLight',
  extrabold: 'ExtraBold',
  black: 'Black',
  heavy: 'Black',
  // CSS numeric weights
  '100': 'Thin',
  '200': 'ExtraLight',
  '300': 'Light',
  '400': 'Regular',
  '500': 'Medium',
  '600': 'SemiBold',
  '700': 'Bold',
  '800': 'ExtraBold',
  '900': 'Black',
};

/**
 * Возвращает PascalCase суффикс для CSS-веса.
 * Если вес неизвестен — отдаёт `rawWeight` без изменений.
 */
export function normalizeFontWeight(rawWeight: string): string {
  const key = (rawWeight ?? '').toLowerCase();
  return FONT_WEIGHT_NORMALIZE[key] ?? rawWeight;
}
